// extracted by mini-css-extract-plugin
module.exports = {"button":"PageSizeButton_button__347pN"};